export const webappXenv = [
    'hwfastapp'
];
